import { Controller } from "@hotwired/stimulus";
import debounce from "lodash.debounce";

export default class extends Controller {
  static targets = ["form"];

  initialize() {
    this.debouncedReloadForm = debounce(this.reloadForm.bind(this), 500);
  }

  reloadForm() {
    this.resetCompanyId();
    this.formTarget.requestSubmit();
  }

  resetCompanyId() {
    this.formTarget
      .querySelectorAll('input[name="onboarding_company_form[company_id]"]')
      .forEach((input) => {
        if (input.type === "hidden") {
          input.value = "";
        } else if (input.type === "radio") {
          input.checked = false;
        }
      });
  }
}
